import React from 'react';

// Set is wrapped in array to trigger rerender when using setSet
// because each time it'll be a new array

const useSet = (initialValues = []) => {
  const [[set], setSet] = React.useState([new Set(initialValues)]);

  const stableActions = React.useMemo(() => {
    const add = (item) =>
      setSet(([prevSet]) => {
        prevSet.add(item);
        return [prevSet];
      });

    const remove = (item) =>
      setSet(([prevSet]) => {
        prevSet.delete(item);
        return [prevSet];
      });

    const toggle = (item) =>
      setSet(([prevSet]) => {
        if (prevSet.has(item)) {
          prevSet.delete(item);
        } else {
          prevSet.add(item);
        }

        return [prevSet];
      });

    const reset = () => setSet([new Set(initialValues)]);

    return { add, delete: remove, remove, toggle, reset };
  }, [initialValues]);

  const utils = {
    has: React.useCallback((item) => set.has(item), [set]),
    ...stableActions,
  };

  return [set, utils];
};

export default useSet;
